export enum SubmissionPeriodOverdueSetting {
  submissionDate = "submissionDate",
  firstSubmissionDate = "firstSubmissionDate",
}
